import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map,Observable } from 'rxjs';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
    private utility: UtilityService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  GetAttendanceCalendar(Detail: any): Observable<any> {
    return this.utility.callWithRetry('GetAttendanceCalendar/Details', Detail);
    // return this.http.post<any>(environment.API_URL + `GetAttendanceCalendar/Details`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  ESS_GetESSAttendanceSummaryWeb(Detail: any): Observable<any>  {
    return this.utility.callWithRetry('ESS_GetESSAttendanceSummary/Web', Detail);
    // return this.http.post<any>(environment.API_URL + `ESS_GetESSAttendanceSummary/Web`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  
}
